import { fetchCartJson, setCartCheckout } from "@theme/utilities";
import { renderCartSection, trackCartRequest } from "@theme/section-renderer";
(() => {
  function init() {
    var _a2;
    const actions = (_a2 = window.Shopify) == null ? void 0 : _a2.actions;
    actions && (actions.updateCart.configure({ eventTarget: () => {
      var _a3;
      return (_a3 = document.querySelector("theme-drawer#cart-drawer")) != null ? _a3 : document;
    } }), actions.openCart.configure({ async handler() {
      const drawer = document.querySelector("theme-drawer#cart-drawer");
      (drawer == null ? void 0 : drawer.open) ? drawer.open() : window.location.href = Theme.routes.cart_url || "/cart";
    } }));
  }
  var _a;
  ((_a = window.Shopify) == null ? void 0 : _a.actions) ? init() : document.addEventListener("DOMContentLoaded", init, { once: true });
  (function() {
    var _a2, _b, _c;
    if (window.__pbQuickAdd) return;
    window.__pbQuickAdd = 1;
    function m(c) {
      if (!Number.isFinite(c) || c < 0 || !text.currency) throw new Error(text.error);
      return new Intl.NumberFormat(text.locale || document.documentElement.lang, { style: "currency", currency: text.currency }).format(c / 100);
    }
    const root = ((_b = (_a2 = window.Shopify) == null ? void 0 : _a2.routes) == null ? void 0 : _b.root) || "/";
    const text = JSON.parse(((_c = document.getElementById("pb-card-add-text")) == null ? void 0 : _c.textContent) || "{}");
    const checkoutOwner = {};
    let pendingAdd = false;
    let reviewMessage = "";
    let pickerController;
    let pickerGeneration = 0;
    function announce(message, review = false) {
      let region = document.getElementById("pb-quick-add-status");
      if (!region) {
        region = document.createElement("div");
        region.id = "pb-quick-add-status";
        region.className = "pb-card-add-status";
        region.setAttribute("role", "status");
        document.body.appendChild(region);
      }
      region.textContent = message;
      region.hidden = false;
      region.classList.toggle("pb-card-add-status--review", review);
      clearTimeout(region.hideTimer);
      if (!review) region.hideTimer = setTimeout(() => {
        region.hidden = true;
      }, 6500);
      if (review) {
        const link = document.createElement("a");
        link.href = root + "cart";
        link.className = "pb-card-review-link";
        link.textContent = text.view_cart;
        region.appendChild(link);
      }
    }
    let drawerController;
    function bubble() {
      var event = new CustomEvent("pb:cart-count-refresh");
      event.promise = Promise.resolve({});
      document.dispatchEvent(event);
      return Promise.resolve();
    }
    async function refreshDrawer(open) {
      if (drawerController) drawerController.abort();
      const wrap = document.querySelector("#shopify-section-cart-drawer-section");
      if (!wrap) {
        if (open) location.href = root + "cart";
        return;
      }
      const controller = new AbortController();
      drawerController = controller;
      const timeout = setTimeout(() => controller.abort(), 15e3);
      try {
        await renderCartSection("cart-drawer-section", null, {
          mode: "hydration",
          injectStylesheet: true,
          signal: controller.signal,
          expectedElement: wrap,
          requiredSelector: 'theme-drawer [data-hydration-key="cart-drawer-inner"]'
        }, null);
        if (controller.signal.aborted || drawerController !== controller || document.querySelector("#shopify-section-cart-drawer-section") !== wrap) throw new Error(text.added_review);
        if (open) {
          const drawer = wrap.querySelector("theme-drawer");
          if (!drawer || typeof drawer.open !== "function") throw new Error(text.added_review);
          if (!drawer.hasAttribute("open")) drawer.open();
        }
      } finally {
        clearTimeout(timeout);
        if (drawerController === controller) drawerController = null;
      }
    }
    async function addToCart(id, quantity = 1, beforeDrawerOpen) {
      if (pendingAdd || reviewMessage) {
        const error = new Error(reviewMessage || text.adding);
        error.quickAddHandled = true;
        announce(error.message, Boolean(reviewMessage));
        throw error;
      }
      if (!Number.isSafeInteger(Number(id)) || Number(id) <= 0 || !Number.isInteger(quantity) || quantity <= 0) throw new Error(text.error);
      pendingAdd = true;
      setCartCheckout(checkoutOwner, "pending");
      let confirmed = false;
      try {
        const request = fetchCartJson(root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(id), quantity }] })
        }, new AbortController(), 3e4);
        trackCartRequest(request);
        const result = await request;
        const lines = result && Array.isArray(result.items) ? result.items : [result];
        if (!result || result.status || !lines.some((line) => line && String(line.variant_id || line.id) === String(id) && Number.isInteger(line.quantity) && line.quantity >= quantity)) throw new Error(text.review);
        confirmed = true;
        const cart = await fetchCartJson(root + "cart.js", {
          headers: { Accept: "application/json" },
          cache: "no-store"
        }, new AbortController(), 15e3);
        if (!cart || !Array.isArray(cart.items) || !Number.isInteger(cart.item_count) || cart.item_count < 0 || !cart.items.some((line) => String(line.variant_id || line.id) === String(id) && Number(line.quantity) >= quantity)) throw new Error(text.added_review);
        await bubble();
        if (beforeDrawerOpen) beforeDrawerOpen();
        await refreshDrawer(true);
        announce(text.added);
      } catch (failure) {
        reviewMessage = confirmed ? text.added_review : text.review;
        const error = new Error(reviewMessage);
        error.quickAddHandled = true;
        announce(reviewMessage, true);
        throw error;
      } finally {
        pendingAdd = false;
        setCartCheckout(checkoutOwner, reviewMessage ? "failed" : null);
      }
    }
    function closeModal(expected) {
      var _a3;
      const ov = document.getElementById("pb-qa");
      if (!ov || expected && expected !== ov) return;
      if (ov.open) ov.close();
      ov.remove();
      if (((_a3 = ov.returnFocus) == null ? void 0 : _a3.isConnected) && !ov.returnFocus.disabled) ov.returnFocus.focus();
    }
    function openModal(p, url, trigger) {
      closeModal();
      const ov = document.createElement("dialog");
      if (typeof ov.showModal !== "function") {
        location.href = url;
        return;
      }
      ov.id = "pb-qa";
      ov.className = "pb-qa";
      ov.setAttribute("aria-labelledby", "pb-qa-title");
      ov.returnFocus = trigger || document.activeElement;
      Object.assign(ov.style, { margin: "0", width: "100%", maxWidth: "none", height: "100%", maxHeight: "none", border: "0", boxSizing: "border-box" });
      ov.addEventListener("cancel", function(event) {
        event.preventDefault();
        closeModal(ov);
      });
      ov.addEventListener("close", function() {
        if (document.getElementById("pb-qa") === ov) closeModal(ov);
      });
      var card = document.createElement("div");
      card.className = "pb-qa__card";
      card.style.maxHeight = "100%";
      card.style.overflowY = "auto";
      var x = document.createElement("button");
      x.type = "button";
      x.className = "pb-qa__close";
      x.setAttribute("aria-label", text.close);
      x.innerHTML = "&#10005;";
      var media = document.createElement("div");
      media.className = "pb-qa__media";
      var img = document.createElement("img");
      img.alt = p.title || "";
      if (p.featured_image) {
        img.src = p.featured_image;
      }
      media.appendChild(img);
      var body = document.createElement("div");
      body.className = "pb-qa__body";
      var a = document.createElement("a");
      a.id = "pb-qa-title";
      a.className = "pb-qa__title";
      a.href = url;
      a.textContent = (p.title || "").replace("PerfectBaby™ ", "");
      var price = document.createElement("p");
      price.className = "pb-qa__price";
      var selWrap = document.createElement("div");
      selWrap.className = "pb-qa__select-wrap";
      var sel = document.createElement("select");
      sel.className = "pb-qa__select";
      sel.setAttribute("aria-label", text.variant);
      const requestedId = new URL(url, location.href).searchParams.get("variant");
      const selected = p.variants.find((v) => String(v.id) === requestedId) || p.variants.find((v) => v.available) || p.variants[0];
      p.variants.forEach(function(v) {
        var o = document.createElement("option");
        o.value = v.id;
        o.textContent = v.title + (v.available ? "" : " — " + text.sold_out);
        o.disabled = !v.available;
        if (v === selected) {
          o.selected = true;
        }
        sel.appendChild(o);
      });
      sel.value = String(selected.id);
      selWrap.appendChild(sel);
      var add = document.createElement("button");
      add.type = "button";
      add.className = "pb-qa__add";
      add.textContent = text.add_to_cart;
      const status = document.createElement("p");
      status.setAttribute("role", "status");
      status.hidden = true;
      let modalComplete = false;
      function cur() {
        var id = parseInt(sel.value, 10);
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].id === id) return p.variants[i];
        }
        return p.variants[0];
      }
      function upd() {
        var v = cur();
        price.textContent = m(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          const previousPrice = document.createElement("s");
          previousPrice.textContent = m(v.compare_at_price);
          price.appendChild(previousPrice);
        }
        const selectedUrl = new URL(url, location.href);
        selectedUrl.searchParams.set("variant", String(v.id));
        a.href = selectedUrl.toString();
        if (!add.dataset.busy && !modalComplete) add.textContent = v.available ? text.add_to_cart : text.sold_out;
        if (v.featured_image && v.featured_image.src) img.src = v.featured_image.src;
        else if (p.featured_image) img.src = p.featured_image;
        else img.removeAttribute("src");
        add.disabled = !v.available || pendingAdd || Boolean(reviewMessage) || modalComplete;
      }
      sel.addEventListener("change", upd);
      upd();
      add.addEventListener("click", function() {
        var _a3, _b2;
        if (add.dataset.busy || modalComplete) return;
        if (!((_a3 = cur()) == null ? void 0 : _a3.available)) return;
        add.dataset.busy = "1";
        add.disabled = true;
        sel.disabled = true;
        var old = add.textContent;
        add.textContent = text.adding;
        addToCart(cur().id, Number((_b2 = cur().quantity_rule) == null ? void 0 : _b2.min) || 1, () => closeModal(ov)).then(function() {
          modalComplete = true;
          add.textContent = text.added;
        }).catch(function(error) {
          add.textContent = old;
          status.textContent = error.message;
          status.hidden = false;
          const cartLink = document.createElement("a");
          cartLink.href = root + "cart";
          cartLink.textContent = text.view_cart;
          status.appendChild(cartLink);
        }).finally(function() {
          delete add.dataset.busy;
          sel.disabled = false;
          upd();
        });
      });
      body.appendChild(a);
      body.appendChild(price);
      if (p.variants.length > 1) {
        body.appendChild(selWrap);
      }
      body.appendChild(status);
      body.appendChild(add);
      card.appendChild(x);
      card.appendChild(media);
      card.appendChild(body);
      ov.appendChild(card);
      ov.addEventListener("click", function(e) {
        if (e.target === ov) closeModal(ov);
      });
      x.addEventListener("click", () => closeModal(ov));
      document.body.appendChild(ov);
      ov.showModal();
      (p.variants.length > 1 ? sel : add.disabled ? x : add).focus();
    }
    document.addEventListener("click", function(e) {
      var b = e.target && e.target.closest ? e.target.closest("quick-add-component button.quick-add__button") : null;
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var qa = b.closest("quick-add-component");
      var host = qa.closest("product-card") || qa.closest(".product-card") || qa.closest("product-hotspot-component") || document;
      var link = host.querySelector('a[href*="/products/"]');
      if (!link) {
        return;
      }
      var url = link.href;
      if (b.dataset.pbBusy) return;
      b.dataset.pbBusy = "1";
      if (pendingAdd || reviewMessage) {
        delete b.dataset.pbBusy;
        announce(reviewMessage || text.adding, Boolean(reviewMessage));
        return;
      }
      const generation = ++pickerGeneration;
      if (pickerController) pickerController.abort();
      const controller = new AbortController();
      pickerController = controller;
      const productUrl = new URL(url);
      productUrl.pathname = productUrl.pathname.replace(/\/$/, "") + ".js";
      fetchCartJson(productUrl, { headers: { Accept: "application/json" }, cache: "no-store" }, controller, 15e3).then(function(p) {
        var _a3;
        if (generation !== pickerGeneration || !b.isConnected) return;
        if (!p || !Array.isArray(p.variants) || !p.variants.length) throw new Error(text.error);
        const avail = p.variants.filter((v) => v.available);
        if (!avail.length) throw new Error(text.sold_out);
        if (p.variants.length === 1 && avail.length === 1) return addToCart(avail[0].id, Number((_a3 = avail[0].quantity_rule) == null ? void 0 : _a3.min) || 1);
        openModal(p, url, b);
      }).catch(function(error) {
        if (error.quickAddHandled || controller.signal.aborted || generation !== pickerGeneration || !b.isConnected) {
          if (error.name === "TimeoutError" && generation === pickerGeneration && b.isConnected) location.href = url;
          return;
        }
        location.href = url;
      }).finally(function() {
        if (pickerController === controller) pickerController = null;
        delete b.dataset.pbBusy;
      });
    }, true);
  })();
})();
